export const patients = [
  {
    name: 'William, Gwen Marry',
    mr: '22351612',
    dob: '03/06/2006 (20 yrs)',
    sex: 'Female'
  },
  {
    name: 'Philip, Cammiee John',
    mr: '22351684',
    dob: '05/12/1998 (28 yrs)',
    sex: 'Female'
  },
  {
    name: 'Johnson, Arjun Kumar',
    mr: '22351690',
    dob: '11/22/1985 (40 yrs)',
    sex: 'Male'
  },
  {
    name: 'Mary, Anitha Rose',
    mr: '22351701',
    dob: '08/14/1992 (33 yrs)',
    sex: 'Female'
  },
  {
    name: 'Kumar, Ravi Shankar',
    mr: '22351718',
    dob: '01/19/1978 (48 yrs)',
    sex: 'Male'
  }
];